import { useState, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import NavigationDropdown from "../../components/NavigationDropdown";
import NavigationPanel from "../../components/NavigationPanel";
import PortalPopup from "../../components/PortalPopup";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import DownloadModalTables from "../../components/DownloadModalTables";
import Breadcrumb from "../../components/Breadcrumb";
import CTAs from "../../components/CTAs";
import PoweredByAITag from "../../components/PoweredByAITag";
import Footer from "../../components/Footer";
import { SearchNormal1 } from "iconsax-reactjs";

const Defence_4 = () => {
  const navigate = useNavigate();
  const [isNavigationDropdownOpen, setNavigationDropdownOpen] = useState(false);
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);
  const [isDownloadModalTablesOpen, setDownloadModalTablesOpen] =
    useState(false);

  const closeNavigationDropdown = useCallback(() => {
    setNavigationDropdownOpen(false);
  }, []);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const openDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(true);
  }, []);

  const closeDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(false);
  }, []);

  const onTabStatesContainerClick = useCallback(() => {
    navigate("/defence2");
  }, [navigate]);

  const onTabStatesContainer1Click = useCallback(() => {
    navigate("/defence3");
  }, [navigate]);

  const breadcrumb = [
    { label: "Defence and Case Handling", path: "/defence1", active: false },
    { label: "Paras Mistry", path: "", active: true },
  ];

  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const communications = [
    {
      title: "Email sent",
      status: "Successful",
      date: "08 Feb 2025 - 10:00 AM",
    },
    {
      title: "Attempted call",
      status: "No response",
      date: "08 Feb 2025 - 10:00 AM",
    },
    {
      title: "Call rejected",
      status: "No response",
      date: "08 Feb 2025 - 10:00 AM",
    },
  ];

  const filterDocuments =
    activeTab === "all"
      ? communications
      : communications.filter(
          (communication) =>
            document.kind.toLowerCase() === activeTab.toLowerCase()
        );

  const searchedDocuments = filterDocuments.filter(
    (communication) =>
      communication.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      communication.status.toLowerCase().includes(searchQuery.toLowerCase()) ||
      communication.date.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const statusColorMap = {
    "No response": "bg-red-100 text-red-500 border-red-500",
    Successful: "bg-green-100 text-green-500 border-green-500",
  };

  const statusIconMap = {
    "No response": "•",
    Successful: "•",
  };

  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-sm text-neutrals-neutral-900 font-open-sans-font-family-meta-strong">
        {/* Navigation Panel */}
        <NavigationPanel />

        {/* Main */}
        <div className="w-full absolute top-[136px] flex flex-col items-start justify-start gap-6 px-4 md:px-4 lg:px-24 box-border">
          {/* Breadcrumb Navigation */}
          <Breadcrumb breadcrumbs={breadcrumb} />

          {/* Heading */}
          <div className="self-stretch bg-white border-neutrals-neutral-100 border-solid border-b-[1px] flex flex-col items-start justify-start pt-0 px-0 pb-6 text-9xl text-neutrals-neutral-900">
            <div className="self-stretch flex flex-row items-start justify-start">
              <div className="flex flex-col items-start justify-start gap-1.5">
                <b className="relative">Defence and Case Handling</b>
                <div className="relative text-base text-neutrals-neutral-300">
                  Acknowledge defences and revert back.
                </div>
              </div>
            </div>
          </div>

          <div className="self-stretch flex flex-col items-start justify-start gap-6 text-base">
            {/* Tabs */}
            <div className="flex flex-row items-start justify-start gap-6">
              <div
                className="bg-white h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
                onClick={onTabStatesContainerClick}
              >
                <div className="flex flex-row items-center justify-center">
                  <div className="relative font-semibold">Case details</div>
                </div>
              </div>
              <div
                className="bg-white h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
                onClick={onTabStatesContainer1Click}
              >
                <div className="flex flex-row items-center justify-center">
                  <div className="relative font-semibold">AI utilisation</div>
                </div>
              </div>
              <div className="bg-white border-primary-primary-500 border-solid border-b-[2px] box-border h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 text-primary-primary-500">
                <div className="flex flex-row items-center justify-center">
                  <div className="relative font-semibold">Negotiation</div>
                </div>
              </div>
            </div>

            <div className="self-stretch flex flex-col items-start justify-start gap-8 text-lg text-neutrals-neutral-900">
              {/* Sub-heading */}
              <div className="w-full flex flex-col items-start justify-start pt-0 gap-[10px] text-lg">
                <div className="w-full relative border-neutrals-neutral-100 border-solid border-b-[1px] box-border flex flex-row items-start justify-between pt-0 px-0 pb-6 gap-0 text-left text-lg text-neutrals-neutral-900 font-open-sans-font-family-meta-strong">
                  <div className="flex flex-col items-start justify-start gap-1.5">
                    <div className="relative font-semibold">
                      Communication panel
                    </div>
                    <div className="relative text-base text-neutrals-neutral-300">
                      Acknowledges any formal defence raised by the debtor.
                    </div>
                  </div>
                  <PoweredByAITag />
                </div>
              </div>

              {/* Chat window- Start */}
              <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 border-neutrals-neutral-100 border-solid border-[1px] box-border h-[555px] flex flex-col items-start justify-between p-6 gap-0 text-sm">
                <div className="self-stretch flex flex-row items-center justify-between pt-0 px-0 pb-6 border-b-[1px] border-solid border-neutrals-neutral-100">
                  <div className="flex flex-col items-start justify-start gap-[75px]">
                    <div className="flex flex-row items-start justify-start gap-[10px]">
                      <div className="flex flex-row items-start justify-start relative gap-[10px]">
                        <div className="flex flex-row items-start justify-start relative gap-[10px] z-[0]">
                          <div className="rounded-81xl bg-primary-primary-50 flex flex-row items-start justify-start p-2.5 z-[0]">
                            <img
                              className="w-5 relative h-5 overflow-hidden shrink-0"
                              alt=""
                              src="assets/AI.svg"
                            />
                          </div>
                          <div className="w-2.5 absolute !m-[0] top-[30px] left-[30px] rounded-[50%] bg-primary-primary-500 box-border h-2.5 z-[1] border-[1px] border-solid border-neutrals-neutral-50" />
                        </div>
                        <div className="w-2.5 absolute !m-[0] top-[30px] left-[30px] rounded-[50%] bg-primary-primary-500 box-border h-2.5 z-[1] border-[1px] border-solid border-neutrals-neutral-50" />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-[6px]">
                        <div className="w-[308px] flex flex-row items-start justify-between">
                          <div className="relative font-semibold">AI bot</div>
                          <div className="relative text-neutrals-neutral-300 text-right">
                            Monday 2:30 pm
                          </div>
                        </div>
                        <div className="w-[308px] rounded-tl-none rounded-tr-3xs rounded-b-3xs bg-neutrals-neutral-50 box-border flex flex-row items-center justify-center py-2.5 px-3.5 text-base border-[1px] border-solid border-neutrals-neutral-100">
                          <div className="flex-1 relative">
                            Hey Nathan, can you please review the documents I
                            uploaded.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col items-end justify-start gap-[6px]">
                      <div className="flex flex-row items-start justify-start gap-[10px]">
                        <div className="flex flex-row items-start justify-start relative gap-[10px]">
                          <div className="flex flex-row items-start justify-start relative gap-[10px] z-[0]">
                            <div className="rounded-81xl bg-primary-primary-50 flex flex-row items-start justify-start p-2.5 z-[0]">
                              <img
                                className="w-5 relative h-5 overflow-hidden shrink-0"
                                alt=""
                                src="assets/AI.svg"
                              />
                            </div>
                            <div className="w-2.5 absolute !m-[0] top-[30px] left-[30px] rounded-[50%] bg-primary-primary-500 box-border h-2.5 z-[1] border-[1px] border-solid border-neutrals-neutral-50" />
                          </div>
                          <div className="w-2.5 absolute !m-[0] top-[30px] left-[30px] rounded-[50%] bg-primary-primary-500 box-border h-2.5 z-[1] border-[1px] border-solid border-neutrals-neutral-50" />
                        </div>
                        <div className="flex flex-col items-start justify-start gap-[6px]">
                          <div className="w-[308px] flex flex-row items-start justify-between">
                            <div className="relative font-semibold">AI bot</div>
                            <div className="relative text-neutrals-neutral-300 text-right">
                              Monday 2:36 pm
                            </div>
                          </div>
                          <div className="w-[308px] rounded-tl-none rounded-tr-3xs rounded-b-3xs bg-neutrals-neutral-50 box-border flex flex-col items-start justify-start py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100">
                            <div className="self-stretch flex flex-row items-start justify-start gap-[10px]">
                              <div className="rounded-3xs bg-neutrals-neutral-50 flex flex-row items-start justify-start p-2.5 border-[1px] border-solid border-neutrals-neutral-100">
                                <img
                                  className="w-5 relative h-5"
                                  alt=""
                                  src="assets/document.svg"
                                />
                              </div>
                              <div className="flex-1 flex flex-col items-start justify-start gap-[6px]">
                                <div className="self-stretch relative font-semibold">
                                  File_name.pdf
                                </div>
                                <div className="self-stretch relative text-neutrals-neutral-300">
                                  1.2MB
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-row items-start justify-end gap-[4px] text-center">
                        <div className="rounded-81xl bg-primary-primary-50 flex flex-col items-center justify-center py-1 px-2">
                          <div className="relative">❤️</div>
                        </div>
                        <div className="rounded-81xl bg-primary-primary-50 flex flex-col items-center justify-center py-1 px-2">
                          <div className="relative">👍🏻</div>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-row items-start justify-start gap-[10px]">
                      <div className="flex flex-row items-start justify-start relative gap-[10px]">
                        <div className="flex flex-row items-start justify-start relative gap-[10px] z-[0]">
                          <div className="rounded-81xl bg-primary-primary-50 flex flex-row items-start justify-start p-2.5 z-[0]">
                            <img
                              className="w-5 relative h-5 overflow-hidden shrink-0"
                              alt=""
                              src="assets/AI.svg"
                            />
                          </div>
                          <div className="w-2.5 absolute !m-[0] top-[30px] left-[30px] rounded-[50%] bg-primary-primary-500 box-border h-2.5 z-[1] border-[1px] border-solid border-neutrals-neutral-50" />
                        </div>
                        <div className="w-2.5 absolute !m-[0] top-[30px] left-[30px] rounded-[50%] bg-primary-primary-500 box-border h-2.5 z-[1] border-[1px] border-solid border-neutrals-neutral-50" />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-[6px]">
                        <div className="relative font-semibold">AI bot</div>
                        <div className="rounded-tl-none rounded-tr-3xs rounded-b-3xs bg-neutrals-neutral-50 flex flex-col items-start justify-start py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100">
                          <div className="flex flex-row items-start justify-start gap-[4px]">
                            <div className="flex flex-row items-start justify-start pt-1 px-0 pb-0">
                              <div className="w-1 relative rounded-[50%] bg-neutrals-neutral-200 h-1" />
                            </div>
                            <div className="flex flex-row items-end justify-start pt-1 px-0 pb-0">
                              <div className="w-1 relative rounded-[50%] bg-neutrals-neutral-900 h-1" />
                            </div>
                            <div className="flex flex-row items-end justify-start pt-1 px-0 pb-0">
                              <div className="w-1 relative rounded-[50%] bg-neutrals-neutral-300 h-1" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-[267px] flex flex-col items-end justify-between">
                    <div className="flex flex-row items-start justify-start">
                      <div className="flex flex-col items-start justify-start gap-[6px]">
                        <div className="w-[308px] flex flex-row items-start justify-between">
                          <div className="relative font-semibold">
                            Nathan James
                          </div>
                          <div className="relative text-neutrals-neutral-300 text-right">
                            Monday 2:35 pm
                          </div>
                        </div>
                        <div className="w-[308px] rounded-tl-3xs rounded-tr-none rounded-b-3xs bg-primary-primary-500 flex flex-row items-center justify-center py-2.5 px-3.5 box-border text-base text-neutrals-neutral-50">
                          <div className="flex-1 relative">
                            Hey [Client_name], sure will have a look at the file
                            once.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-row items-start justify-start">
                      <div className="flex flex-col items-start justify-start gap-[6px]">
                        <div className="w-[308px] flex flex-row items-start justify-between">
                          <div className="relative font-semibold">
                            Nathan James
                          </div>
                          <div className="relative text-neutrals-neutral-300 text-right">
                            Monday 2:45 pm
                          </div>
                        </div>
                        <div className="w-[308px] rounded-tl-3xs rounded-tr-none rounded-b-3xs bg-primary-primary-500 flex flex-row items-center justify-center py-2.5 px-3.5 box-border text-base text-neutrals-neutral-50">
                          <div className="flex-1 relative">
                            Hi [Client_name], I have seen the file and it seems
                            good to me.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="self-stretch flex flex-row items-center justify-between py-4 gap-4 text-base text-neutrals-neutral-300">
                  <div className="w-full shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border flex flex-row items-start justify-start py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100">
                    <div className="relative whitespace-pre-wrap">
                      Write your message here...
                    </div>
                  </div>
                  <div className="gap-3 flex flex-row">
                    <CTAs
                      type="Secondarybtn"
                      text="Upload"
                      borderColor="border-neutrals-neutral-100"
                      position="relative"
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M9 17.748c-.41 0-.75-.34-.75-.75v-4.19l-.72.72c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06l2-2c.21-.21.54-.28.82-.16.28.11.46.39.46.69v6c0 .41-.34.75-.75.75Z"
                            fill="#2d404e"
                          ></path>
                          <path
                            d="M11 13.751c-.19 0-.38-.07-.53-.22l-2-2a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2 2c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22Z"
                            fill="#2d404e"
                          ></path>
                          <path
                            d="M15 22.75H9c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h5c.41 0 .75.34.75.75s-.34.75-.75.75H9C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25v-5c0-.41.34-.75.75-.75s.75.34.75.75v5c0 5.43-2.32 7.75-7.75 7.75Z"
                            fill="#2d404e"
                          ></path>
                          <path
                            d="M22 10.748h-4c-3.42 0-4.75-1.33-4.75-4.75v-4c0-.3.18-.58.46-.69.28-.12.6-.05.82.16l8 8a.751.751 0 0 1-.53 1.28Zm-7.25-6.94v2.19c0 2.58.67 3.25 3.25 3.25h2.19l-5.44-5.44Z"
                            fill="#2d404e"
                          ></path>
                        </svg>
                      }
                    />

                    <CTAs
                      type="Gradientbtn"
                      text="Send"
                      borderColor="border-primary-primary-500"
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="m18.07 8.509-8.56-4.28c-5.75-2.88-8.11-.52-5.23 5.23l.87 1.74c.25.51.25 1.1 0 1.61l-.87 1.73c-2.88 5.75-.53 8.11 5.23 5.23l8.56-4.28c3.84-1.92 3.84-5.06 0-6.98Zm-3.23 4.24h-5.4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5.4c.41 0 .75.34.75.75s-.34.75-.75.75Z"
                            fill="#ffffff"
                          ></path>
                        </svg>
                      }
                    />
                  </div>
                </div>
              </div>

              {/* Table */}
              <div className="w-full flex flex-col items-start justify-start">
                <div className="w-full rounded-t-3xs rounded-b-none box-border flex flex-row items-center justify-between py-5 px-6 text-lg border-t-[1px] border-solid border-neutrals-neutral-100 border-r-[1px] border-l-[1px]">
                  <div className="flex flex-row items-center justify-start gap-[10px]">
                    <div className="relative font-semibold">
                      Recent communication
                    </div>
                    <div className="rounded-[5px] bg-neutrals-neutral-50 flex flex-row items-center justify-start py-0.5 px-2 gap-[6px] text-sm border-[1px] border-solid border-neutrals-neutral-100">
                      <div className="w-1.5 relative rounded-[50%] bg-primary-primary-500 h-1.5" />
                      <div className="relative font-semibold">2 entries</div>
                    </div>
                  </div>
                  <CTAs
                    type="Secondarybtn"
                    text="Download all"
                    borderColor="border-neutrals-neutral-100"
                    icon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M9 17.75c-.1 0-.19-.02-.29-.06a.74.74 0 0 1-.46-.69v-6c0-.41.34-.75.75-.75s.75.34.75.75v4.19l.72-.72c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-2 2c-.14.14-.34.22-.53.22Z"
                          fill="#2d404e"
                        ></path>
                        <path
                          d="M9 17.751c-.19 0-.38-.07-.53-.22l-2-2a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2 2c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22Z"
                          fill="#2d404e"
                        ></path>
                        <path
                          d="M15 22.75H9c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h5c.41 0 .75.34.75.75s-.34.75-.75.75H9C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25v-5c0-.41.34-.75.75-.75s.75.34.75.75v5c0 5.43-2.32 7.75-7.75 7.75Z"
                          fill="#2d404e"
                        ></path>
                        <path
                          d="M22 10.748h-4c-3.42 0-4.75-1.33-4.75-4.75v-4c0-.3.18-.58.46-.69.28-.12.6-.05.82.16l8 8a.751.751 0 0 1-.53 1.28Zm-7.25-6.94v2.19c0 2.58.67 3.25 3.25 3.25h2.19l-5.44-5.44Z"
                          fill="#2d404e"
                        ></path>
                      </svg>
                    }
                    position="relative"
                  />
                </div>
                <div className="w-full box-border flex flex-row items-center justify-between py-3 px-6 border-t-[1px] border-solid border-neutrals-neutral-100 border-r-[1px] border-l-[1px] text-sm">
                  <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-start border-[1px] border-solid border-neutrals-neutral-100">
                    <div className="rounded-tl-3xs rounded-tr-none rounded-br-none rounded-bl-3xs bg-column-bg flex flex-row items-center justify-center py-2 px-4 border-r-[1px] border-solid border-neutrals-neutral-100">
                      <div className="relative font-semibold">View all</div>
                    </div>
                    <div className="flex flex-row items-center justify-center py-2 px-4 border-r-[1px] border-solid border-neutrals-neutral-100">
                      <div className="relative font-semibold">No response</div>
                    </div>
                    <div className="rounded-tl-none rounded-tr-3xs rounded-br-3xs rounded-bl-none flex flex-row items-center justify-center py-2 px-4">
                      <div className="relative font-semibold">Successful</div>
                    </div>
                  </div>
                  <div className="flex flex-row items-start justify-start gap-[10px] text-neutrals-neutral-300">
                    <div className="w-[294px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border flex flex-row items-center justify-start py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100">
                      <div className="flex flex-row items-center justify-start gap-2.5">
                        <SearchNormal1 size={20} color="#2D404E" />
                        <div className="relative">Search</div>
                      </div>
                    </div>
                    <CTAs
                      type="Secondarybtn"
                      text="Filter"
                      borderColor="border-neutrals-neutral-100"
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M21 7.75H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75ZM18 12.75H6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h12c.41 0 .75.34.75.75s-.34.75-.75.75ZM14 17.75h-4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75Z"
                            fill="#2d404e"
                          ></path>
                        </svg>
                      }
                      position="relative"
                    />
                  </div>
                </div>
                <div className="w-full flex flex-col items-start justify-start text-sm">
                  <div className="w-full flex flex-col items-start justify-start">
                    <table className="w-full min-w-full divide-y divide-gray-200 border-collapse">
                      <thead className="bg-column-bg">
                        <tr>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-l-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong whitespace-nowrap"
                          >
                            Communications
                          </th>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong whitespace-nowrap"
                          >
                            Status
                          </th>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-r-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong whitespace-nowrap"
                          >
                            Date
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-neutrals-neutral-50 divide-y divide-gray-200">
                        {searchedDocuments.map((communications) => (
                          <tr key={communications.id} className="hover:bg-gray">
                            <td className="p-4 border-solid border-b-[1px] border-l-[1px] border-neutrals-neutral-100">
                              {communications.title}
                            </td>
                            <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100 whitespace-nowrap">
                              <span
                                className={`px-2 py-0.5 text-xs font-semibold rounded-full border-solid border-[1px] border-current ${
                                  statusColorMap[communications.status]
                                }`}
                              >
                                <span className="mr-1">
                                  {statusIconMap[communications.status]}
                                </span>
                                {communications.status}
                              </span>
                            </td>
                            <td className="p-4 border-solid border-b-[1px] border-r-[1px] border-neutrals-neutral-100">
                              {communications.date}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagnation */}
                  <div className="w-full rounded-t-none shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-b-3xs box-border flex flex-row items-center justify-between pt-3 px-6 pb-4 border-r-[1px] border-solid border-neutrals-neutral-100 border-b-[1px] border-l-[1px]">
                    <CTAs
                      type="Secondarybtn"
                      text="Previous"
                      borderColor="border-neutrals-neutral-100"
                    />
                    <div className="relative">Page 1 of 10</div>
                    <CTAs
                      type="Secondarybtn"
                      text="Next"
                      borderColor="border-neutrals-neutral-100"
                    />
                  </div>
                </div>
              </div>

              {/* Proposal */}
              <div className="w-fit flex flex-col items-start justify-start gap-6">
                <div className="self-stretch relative font-semibold">
                  Proposal
                </div>
                <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-wireframes-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-col items-start justify-start text-base">
                  <div className="w-full flex flex-col items-start justify-start p-6 box-border gap-2.5">
                    <div className="relative font-semibold">Proposed terms</div>
                    <div className="w-[294px] relative inline-block">
                      Installment plan of £1,000 per month for 2 months.
                    </div>
                  </div>
                  <div className="w-full border-neutrals-neutral-100 border-solid border-t-[1px] box-border flex flex-col items-end justify-start py-4 px-6 text-sm">
                    <div className="flex flex-row items-start justify-end gap-2.5">
                      <CTAs
                        text="Reject"
                        type="Secondarybtn"
                        borderColor="border-neutrals-neutral-100"
                      />
                      <CTAs
                        text="Accept"
                        type="Secondarybtn"
                        borderColor="border-neutrals-neutral-100"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Footer */}
            <Footer />
          </div>
        </div>
      </div>
      {isNavigationDropdownOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeNavigationDropdown}
        >
          <NavigationDropdown onClose={closeNavigationDropdown} />
        </PortalPopup>
      )}
      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
      {isDownloadModalTablesOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeDownloadModalTables}
        >
          <DownloadModalTables onClose={closeDownloadModalTables} />
        </PortalPopup>
      )}
    </>
  );
};

export default Defence_4;
